<template>
  <!-- 栏目布局内容 -->
  <b-container>
    <div class="columnsTitleBox">
      <b-row>
        <b-col sm="12" md="12" lg="3"> </b-col>
        <b-col sm="12" md="12" lg="9"
          ><h1 class="columnsTitleH1">
            <p class="textOVerOdd" style="margin:0">{{ menuSubTitle }}</p>
          </h1>
        </b-col>
      </b-row>
    </div>
    <div class="columnsContent">
      <template v-if="!$mediaStatus">
        <b-row no-gutters>
          <b-col sm="12" md="12" lg="3">
            <div style="margin-top:-50px">
              <ColumnsNav visible v-on:updateColumnsTitle="updateColumnsTitle" />
            </div>
          </b-col>
          <b-col sm="12" md="12" lg="9">
            <div style="min-height:50vh"><slot name="content"></slot></div>
          </b-col>
        </b-row>
      </template>
      <template v-else>
        <ColumnsNav :visible="false" v-on:updateColumnsTitle="updateColumnsTitle" />
        <div style="min-height:50vh"><slot name="content"></slot></div>
      </template>
    </div>
  </b-container>
</template>

<script>
import ColumnsNav from "./columnNav";
// import { mapState } from "vuex";
export default {
  props: ["columnsSubList"],
  components: {
    ColumnsNav,
  },
  data() {
    return {
      web: false, //默认为PC，true为app端
      widthHeight: "100vh",
      columnsTitle: {},
      contentTitle: "",
      menuSubTitle: "",
    };
  },
  methods: {
    updateColumnsTitle(title) {
      this.menuSubTitle = title;
    },
  },
};
</script>

<style scoped></style>
